import React from 'react';
import { Modal, ModalTitle } from 'react-bootstrap';
import { format, isValid, parseISO } from 'date-fns';

interface PanelEditUserProps {
  show: boolean,
  onClose: Function,
  company: any
  launchType: any
}

const ProdutoraDetails: React.FC<PanelEditUserProps> = ({show, onClose, company, launchType}) => {

  let style = {
    borderBottom:'1', borderWidth:'solid', borderColor:'#f1f1f1'
  }
  console.log(company)

  const createdAtComp = company?.createdAt;
  let formattedDateComp = '-/-';

  if (createdAtComp) {
    const date = parseISO(createdAtComp);
    if (isValid(date)) {
      formattedDateComp = format(date, 'dd/MM/yyyy HH:mm');
    }
  }

  const createdAt = company?.launchDate;
  let formattedDate = '-/-';
  if(createdAt){
    const date = parseISO(createdAt);
    formattedDate = isValid(date) ? format(date, 'dd/MM/yyyy') : '-/-';
  }

  return (
    <Modal size="lg" show={show} onHide={() => onClose()} animation={false} centered>
      <Modal.Header closeButton>
        <ModalTitle>Detalhes da Produtora</ModalTitle>
      </Modal.Header>
      <Modal.Body>
        <>
        <table className="table" width="1150px">
          <tr style={style} >
            <td align="left">
              <b>NOME PRODUTORA</b>
            </td>
            <td>
              {company.producerName}
            </td>
          </tr>
          <tr style={style} >
            <td align="left">
              <b>NOME DO FILME</b>
            </td>
            <td>
              {company.movieTitle}
            </td>
          </tr>
          <tr style={style} >
            <td align="left">
              <b>NOME DO PRODUTOR RESPONSAVEL</b>
            </td>
            <td>
              {company.responsibleProducerName}
            </td>
          </tr>
          <tr style={style} >
            <td align="left">
              <b>E-MAIL</b>
            </td>
            <td>
              {company.email}
            </td>
          </tr>
          <tr style={style} >
            <td align="left">
              <b>TELEFONE</b>
            </td>
            <td>
                {company.phone}
            </td>
          </tr>
          <tr style={style} >
            <td align="left">
              <b>REGISTRO ANCINE</b>
            </td>
            <td>
              {company.ancineRegister}
            </td>
          </tr>
          <tr style={style} >
            <td align="left">
              <b>CPB ANCINE</b>
            </td>
            <td>
              {company.cpbAncine}
            </td>
          </tr>
          <tr style={style} >
            <td align="left">
              <b>PLATAFORMA</b>
            </td>
            <td>
              {launchType.name}
            </td>
          </tr>
          <tr style={style} >
            <td align="left">
              <b>DATA ESTRÉIA</b>
            </td>
            <td>
              {formattedDate}
            </td>
          </tr>
          <tr style={style} >
            <td align="left">
              <b>DATA CADASTRO</b>
            </td>
            <td>
              {formattedDateComp}
            </td>
          </tr>
        </table>
        </>
      </Modal.Body>

    </Modal>

  )
}

export default ProdutoraDetails;
